import { instance, GETREQUESTOPTIONS } from '../../apiService';

const API_URL = '/api/cpt-analytics';

export interface AnalyticsOptions {
    techNames: string[];
    cptCodes: string[];
}

export interface DetailedRow {
    date: string;
    techName: string;
    cptCode: string;
    quantity: number;
    rvuPerUnit: number;
    totalRVU: number;
    estimatedRevenue: number;
    deviceType?: string;
}

export interface MonthlyBreakdownItem {
    cptCode: string;
    quantity: number;
    totalRVU: number;
    estimatedRevenue: number;
}

export interface MonthlyRow {
    month: string;
    totalQuantity: number;
    totalRVU: number;
    estimatedRevenue: number;
    breakdown: MonthlyBreakdownItem[];
}

export interface AnalyticsFilters {
    start: string;
    end: string;
    techs?: string[];
    cptCodes?: string[];
}

const toQueryString = (filters: AnalyticsFilters): string => {
    const params = new URLSearchParams({
        start: filters.start,
        end: filters.end,
    });
    if (filters.techs && filters.techs.length > 0) {
        params.set('techs', filters.techs.join(','));
    }
    if (filters.cptCodes && filters.cptCodes.length > 0) {
        params.set('cptCodes', filters.cptCodes.join(','));
    }
    return params.toString();
};

const getAnalyticsOptions = async (
    start: string,
    end: string
): Promise<AnalyticsOptions> => {
    const params = new URLSearchParams({ start, end });
    const response = await instance.get(
        `${API_URL}/options?${params}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const getDetailedAnalytics = async (
    filters: AnalyticsFilters
): Promise<DetailedRow[]> => {
    const response = await instance.get(
        `${API_URL}/detailed?${toQueryString(filters)}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const getMonthlyAnalytics = async (
    filters: AnalyticsFilters
): Promise<MonthlyRow[]> => {
    const response = await instance.get(
        `${API_URL}/monthly?${toQueryString(filters)}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const cptActivityService = {
    getAnalyticsOptions,
    getDetailedAnalytics,
    getMonthlyAnalytics,
};

export default cptActivityService;
